//请自行添加语言资源
const emailReceiveOrderDelay = {
  updateTime:'更新时间',
  lastTaxRate:'最新税率',
  contact:'联系人',
  carrierNo:'物流商编码',
  carrierName:'物流商名称',
  email:'电子邮箱',
  updater:'更新者',
  validPeriodBegin:'有效期开始日期',
  validPeriodEnd: '有效期结束日期',
  taxRate: '税率',
  msg:{
    carrierNo:'请输入物流商编码',
    carrierName:'请输入物流商名称',
  }
};
export default emailReceiveOrderDelay



// WEBPACK FOOTER //
// ./src/page/md/emailReceiveOrderDelay/lang/emailReceiveOrderDelay.zh.js